export { default } from "/Users/ryan/Code/ryanhiebert/meetjesus/app/routes/index.tsx";